import GlobalNotesService from '../../services/GlobalNotesService';

export default {
    state: {
        collection: [],
    },
    getters: {
        getAllGlobalNotes: store => store.collection,
        getAllGlobalNotesFromDatetime: (store, getters) => (date = window.moment()) => getters.getAllGlobalNotes.filter((note) => {
            if (note.publishedDate === null && note.nextPublishedDate === null) {
                return false;
            }

            const first = window.moment(note.publishedDate).isSameOrBefore(window.moment(date));
            const second = window.moment(note.nextPublishedDate).isSameOrBefore(window.moment(date));
            return first || second;
        }),
    },
    mutations: {
        loadGlobalNotes(state, payload) {
            state.collection = payload;
        },
    },
    actions: {
        async loadGlobalNotes(context) {
            try {
                const payload = await GlobalNotesService.getAll();
                context.commit('loadGlobalNotes', payload);
                return payload;
            } catch (error) {
                throw Error(error.message);
            }
        },
    },
    namespaced: true,
};
